import React, { useEffect } from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import AccessAlarmRoundedIcon from '@mui/icons-material/AccessAlarmRounded';
import { useTranslation } from 'react-i18next';

const DuoStreak = ({ onNext, duoStreaks }) => {
  const { t } = useTranslation();
  const limitedDuoStreaks = duoStreaks.slice(0, 3);

  return (
    <Box sx={{ backgroundColor: 'secondary.main', height: '100vh' }}>
      <Box 
        display="flex" 
        flexDirection="column" 
        justifyContent="center" 
        alignItems="center" 
        height="90vh"
        sx={{ px: 3 }} 
      >
        <Box component="img" src="/img/duo.svg" alt="Méditation" width="74vw" />
        
        <Typography variant="h4" sx={{ textAlign: "center", width: '70%' }} mt={2} mb={3}>
          {t('duo_streak_text')}
        </Typography>

        {limitedDuoStreaks.map((duoStreak, index) => {
          const formattedAvatar = duoStreak.partnerAvatar ? duoStreak.partnerAvatar.replace('./', '/') : '/avatar/default-avatar.jpg';
          const hasPartnerMeditated = duoStreak.partnerDidMeditateToday;

          return (
            <Box 
              key={index}
              display="flex" 
              flexDirection="column" 
              justifyContent="center" 
              alignItems="center" 
              width="100%" 
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
                bgcolor="#FFF"
                borderRadius={2}
                p={2}
                mb={1}
              >
                <Box display="flex" alignItems="center">
                  <Avatar 
                    src={formattedAvatar} 
                    alt={duoStreak.duoPartner || 'Partenaire'} 
                    sx={{ width: 48, height: 48, border: '1px solid #DDD' }} 
                  />
                  <Box ml={2}>
                    <Typography sx={{ lineHeight:'1em', mb:1 }} variant="h6" color="textPrimary">
                      {duoStreak.duoPartner || 'Partenaire'}
                    </Typography>

                    <Typography sx={{ lineHeight:'1em' }} variant="body2" color="textSecondary">
                      {hasPartnerMeditated ? t('partner_meditated_today') : t('partner_not_meditated')}
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex" alignItems="center">
                  {hasPartnerMeditated ? (
                    <WhatshotIcon color="primary" />
                  ) : (
                    <AccessAlarmRoundedIcon color="primary" />
                  )}
                  <Typography variant="h6" color="textPrimary" sx={{ ml: 0.5 }}>
                    {duoStreak.currentDuoStreak ?? '0'}
                  </Typography>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default DuoStreak;
